export const OWNERS_PERMISSIONS = {
  SHOW_DATA: 'show_owners',
  CREATE_DATA: 'create_owners',
  EDIT_DATA: 'edit_owners',
  CHANGE_STATE_DATA: 'change_state_owners',
  DELETE_DATA: 'delete_owners',
  EXPORT_EXCEL: 'export_owners',
  IMPORT_EXCEL: 'import_owners',
} as const;
export const OWNERS_PERMISSION_LIST = [
  OWNERS_PERMISSIONS.SHOW_DATA,
  OWNERS_PERMISSIONS.CREATE_DATA,
  OWNERS_PERMISSIONS.EDIT_DATA,
  OWNERS_PERMISSIONS.CHANGE_STATE_DATA,
  OWNERS_PERMISSIONS.DELETE_DATA,
  OWNERS_PERMISSIONS.EXPORT_EXCEL,
  OWNERS_PERMISSIONS.IMPORT_EXCEL,
] as const;
